import React from 'react';
import TextComponent from 'shared/components/TextComponent';

const QFNPlacements = (props) => {
  const name = 'qfn';

  const {
    label,
    errorMessage,
    parameters,
    inputId,
    tooltip,
    groupName,
    onChangeParameter,
    required,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      name={name}
      label={label}
      inputId={inputId}
      value={parameters[name]}
      tooltip={tooltip}
      required={required}
      groupName={groupName}
      onChange={onChange}
      errorMessage={errorMessage}
      disabled={disabled} />
  );
};

QFNPlacements.defaultProps = {
  label: Spree.translations.parameters.qfn,
  tooltip: Spree.helpForParameters.qfn,
  required: true,
  inputId: 'qfn',
};

export default QFNPlacements;
